import React, { ReactNode } from 'react';

type HeadingStyleConfig = {
    fontSize: number;
    fontColor: string;
    fontFamily: string;
};

enum FontFamilyMapper {
    ConvEuropaBold = 'Conv_EuropaBold',
    ConvEuropaRegular = 'Conv_EuropaRegular',
    ConvEuropaLight = 'Conv_EuropaLight',
    BodoniRegular = 'Bodoni_Regular',
    BodoniSmallCaps = 'Bodoni_SmallCaps',
    BodoniBold = 'Bodoni_Bold',
    BodoniOSRegular = 'BodoniOS_Regular',
    BodoniOSBold = 'BodoniOS_Bold',
    BodoniOSItalic = 'BodoniOS_Italic',
    HelveticaNeue = 'Helvetica_Neue',
    HelveticaNeueBold = 'Helvetica_Neue_Bold',
    HelveticaNeueLight = 'Helvetica_Neue_Light',
    Manus = 'Manus'
}

export default function HeadingStylingWrapper<T extends HeadingStyleConfig>({
    children,
    headingConfig,
    varPrefix
}: {
    children: ReactNode;
    headingConfig: T;
    varPrefix: string;
}) {
    const { fontSize, fontColor, fontFamily } = headingConfig;

    const style: Record<string, string> = {
        [`--${varPrefix}-size`]: `${fontSize}px`,
        [`--${varPrefix}-color`]: fontColor,
        [`--${varPrefix}-family`]: FontFamilyMapper[fontFamily] || FontFamilyMapper.BodoniBold
    };

    return <div style={style}>{children}</div>;
}
